import { create } from 'zustand'

interface FooterApStore {
    footer_app: footer_app[] | null
    setFooterApp: (footer_app: footer_app[] | null) => void
    clearFooterApp: () => void
    showProfileNav: boolean
    setShowProfileNav: (show: boolean) => void
}

interface footer_app {
    label: string
    icon: string
    id: string
    active: boolean
    nav?: number
}
export const useFooterApp = create<FooterApStore>((set) => ({
    footer_app: null,
    setFooterApp: (newFooterApp: footer_app[] | null) => {
        try {
            console.log('[footerAppStore] setFooterApp length:', Array.isArray(newFooterApp) ? newFooterApp.length : 'null')
            if (Array.isArray(newFooterApp))
                console.log(
                    '[footerAppStore] labels:',
                    newFooterApp.map((i) => i.label),
                )
        } catch {}
        set({ footer_app: newFooterApp })
    },
    clearFooterApp: () => {
        console.log('[footerAppStore] 🧹 Limpiando footer_app')
        set({ footer_app: null })
    },
    showProfileNav: true,
    setShowProfileNav: (show: boolean) => set({ showProfileNav: show }),
}))
